// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".recycle-img-box[data-v-471626ae]{width:128px}", "",{"version":3,"sources":["D:/SYX/xiaobu-project/kucun-manage/kucun-manage/src/views/D:/SYX/xiaobu-project/kucun-manage/kucun-manage/src/views/D:/SYX/xiaobu-project/kucun-manage/kucun-manage/src/views/recycle-bin.vue"],"names":[],"mappings":"AAEA,kCACE,WAAA","file":"recycle-bin.vue","sourcesContent":["@import \"@/styles/app-variables.scss\";\r\n\r\n.recycle-img-box {\r\n  width: 128px;\r\n}\r\n"]}]);
// Exports
module.exports = exports;
